module.exports = __webpack_public_path__ + "img/drive-migration.93755683.png";